"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _contexts = require("../contexts");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useSnackbar = function useSnackbar() {
  var snackbarContext = _react.default.useContext(_contexts.SnackbarContext);

  if (snackbarContext === undefined) {
    throw new Error('useSnackbar must be used within a SnackbarContext.Provider');
  }

  return snackbarContext.snackbar;
};

var _default = useSnackbar;
exports.default = _default;